<script>
import Navbar from "@/components/navbar";
import FooterBG from "@/components/footer-bg";
export default {
  components: {
    Navbar,
    // Partners,
    // ServicesIt,
    // Testimonial,
    FooterBG,
    // Services,
    // BlogIt,
  }
};
</script>
<template>
  <div>
    <Navbar />

    <div v-scroll-spy>
      <!--START HOME-->
      <section
        class="section bg-home height-100vh"
        id="home"
        :style="{'background-image': 'url(' + require('@/assets/images/fanmath-images/tasks.jpg') + ')', 'background-size': 'cover','background-position': 'center' }"
      >
        <div class="bg-overlay"></div>
        <div class>
          <div class>
            <div class="container slidero">
              <div class="row">
            <div class="col-lg-8 offset-lg-2 text-white text-center">
            <h1 class="home-title">Примерни задачи</h1>
              <h4 class="home-small-title"></h4>
              <p
                class="padding-t-15 home-desc mx-auto"
              ></p>
            </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Particles -->
        <!-- <vue-particles class="position-relative" color="#FFF"></vue-particles> -->

      </section>
      <!--END HOME-->
      
      <!-- <Testimonial /> -->
      <!-- <ServicesIt/> -->
      <!-- <Services/> -->
      <!-- <BlogIt/>
      <Partners /> -->
      <div style="margin-top: 5vh;margin-bottom: 2vh;display: flex;justify-content: center;flex-wrap: wrap;;">
      <img src="@/assets/images/fanmath-images/zadacha1.png" style="width: 50%;margin: 50px; border-style:ridge; border-radius: 9px; border-color: rgb(236, 195, 120);" alt="">
      <img src="@/assets/images/fanmath-images/zadacha2.png" style="width: 50%;margin: 50px; border-style:ridge; border-radius: 9px; border-color: rgb(236, 195, 120);" alt="">
      <img src="@/assets/images/fanmath-images/zadacha3.png" style="width: 50%;margin: 50px; border-style:ridge; border-radius: 9px; border-color: rgb(236, 195, 120);" alt="">
      <img src="@/assets/images/fanmath-images/zadacha4.png" style="width: 50%;margin: 50px; border-style:ridge; border-radius: 9px; border-color: rgb(236, 195, 120);" alt="">
      <img src="@/assets/images/fanmath-images/zadacha5.png" style="width: 50%;margin: 50px; border-style:ridge; border-radius: 9px; border-color: rgb(236, 195, 120);" alt="">
      <img src="@/assets/images/fanmath-images/zadacha6.png" style="width: 50%;margin: 50px; border-style:ridge; border-radius: 9px; border-color: rgb(236, 195, 120);" alt="">
      <img src="@/assets/images/fanmath-images/zadacha7.png" style="width: 50%;margin: 50px; border-style:ridge; border-radius: 9px; border-color: rgb(236, 195, 120);" alt="">
      <img src="@/assets/images/fanmath-images/zadacha8.png" style="width: 50%;margin: 50px; border-style:ridge; border-radius: 9px; border-color: rgb(236, 195, 120);" alt="">
      <img src="@/assets/images/fanmath-images/zadacha9.png" style="width: 50%;margin: 50px; border-style:ridge; border-radius: 9px; border-color: rgb(236, 195, 120);" alt="">
      <img src="@/assets/images/fanmath-images/zadacha10.png" style="width: 50%;margin: 50px; border-style:ridge; border-radius: 9px; border-color: rgb(236, 195, 120);" alt="">
      <img src="@/assets/images/fanmath-images/zadacha11.png" style="width: 50%;margin: 50px; border-style:ridge; border-radius: 9px; border-color: rgb(236, 195, 120);" alt="">
      <img src="@/assets/images/fanmath-images/zadacha12.png" style="width: 50%;margin: 50px; border-style:ridge; border-radius: 9px; border-color: rgb(236, 195, 120);" alt="">
      
    </div>
      <!-- <section
        class="section height-10vh"
        id=""
        :style="{'background-image': 'url(' + require('@/assets/images/fanmath-images/zadacha1.png') + ')', 'background-size': 'cover','background-position': 'center' }"
      >
    </section> -->

      <FooterBG />
    </div>
  </div>
</template>

<style scoped>
@media (max-width: 490px)
{
  img
  {
    scale: 1.6;
  }
}
::v-deep .modal-content {
  background-color: #000000;
  color: white;
  background: none;
  border: none;
}
::v-deep .modal-header {
  border: none;
}
::v-deep .modal-backdrop {
  opacity: 0.5;
}
</style>